/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AboutUs from '../components/AboutUs';
import Accordion from '../components/Accordion';
import AdaptiveImages from '../components/AdaptiveImages';
import Adas from '../components/Adas';
import AppPushModule from '../components/AppPushModule';
import AutoListContent from '../components/Auto-List-Content';
import B2BContact from '../components/B2BContact';
import BalancedDesign from '../components/BalancedDesign';
import BecomeAMember from '../components/BecomeAMember';
import BecomeAMemberFlow from '../components/BecomeAMemberFlow';
import BecomeAMemberSummary from '../components/BecomeAMemberSummary';
import BookingCarDelivery from '../components/BookingCarDelivery';
import BrandDetail from '../components/BrandDetail';
import BrandImageList from '../components/BrandImageList';
import BrandList from '../components/BrandList';
import BrandTechnology from '../components/BrandTechnology';
import Breadcrumbs from '../components/Breadcrumbs';
import CalculationTool from '../components/CalculationTool';
import Car360View from '../components/Car360View';
import Car360ViewV2 from '../components/Car360ViewV2';
import CarBookingConfirmation from '../components/CarBookingConfirmation';
import CarBookingDatetime from '../components/CarBookingDatetime';
import CarBookingDelivery from '../components/CarBookingDelivery';
import CarBookingPayment from '../components/CarBookingPayment';
import CarDeliveryLogin from '../components/CarDeliveryLogin';
import CarModel from '../components/CarModel';
import Cart from '../components/Cart';
import CartAlert from '../components/CartAlert';
import CartRefreshBanner from '../components/CartRefreshBanner';
import ChangeMarketModal from '../components/ChangeMarketModal';
import CheckoutCreateAccount from '../components/CheckoutCreateAccount';
import CheckoutLogin from '../components/CheckoutLogin';
import CheckoutOrderConfirmation from '../components/CheckoutOrderConfirmation';
import CheckoutPayment from '../components/CheckoutPayment';
import CheckoutShippingBilling from '../components/CheckoutShippingBilling';
import CoclubModels from '../components/CoclubModels';
import CoclubSwiper from '../components/CoclubSwiper';
import ColorInChange from '../components/ColorInChange';
import ComparisonTool from '../components/ComparisonTool';
import Consent from '../components/Consent';
import ContactSupport from '../components/ContactSupport';
import ContactSupportDecember from '../components/ContactSupportDecember';
import ContactUs from '../components/ContactUs';
import Cookies from '../components/Cookies';
import Countdown from '../components/Countdown';
import CreateAccount from '../components/CreateAccount';
import CTABanner from '../components/CTA-Banner';
import CTAButton from '../components/CTA-Button';
import CurtainsSlide from '../components/CurtainsSlide';
import DataPrivacyPolicy from '../components/DataPrivacyPolicy';
import DealerMap from '../components/DealerMap';
import DealerSearch from '../components/DealerSearch';
import Declare from '../components/Declare';
import DPP from '../components/DPP';
import DriveModels from '../components/DriveModels';
import Emotive from '../components/Emotive';
import ExploreMore from '../components/ExploreMore';
import FAQ from '../components/FAQ';
import FindDealer from '../components/FindDealer';
import FloatingActionButton from '../components/FloatingActionButton';
import Footer from '../components/Footer';
import FourZeroFourGame from '../components/FourZeroFourGame';
import FreeRolling from '../components/FreeRolling';
import FullScreenBanner from '../components/FullScreenBanner';
import FunPrint from '../components/FunPrint';
import GearLanding from '../components/GearLanding';
import GraphicCombination from '../components/GraphicCombination';
import Header from '../components/Header';
import Helpful from '../components/Helpful';
import HeroBanner from '../components/HeroBanner';
import HeroContent from '../components/HeroContent';
import HeroImage from '../components/HeroImage';
import HeroLanding from '../components/HeroLanding';
import HeroMedia from '../components/HeroMedia';
import HeroSlide from '../components/HeroSlide';
import HeroSlideV2 from '../components/HeroSlideV2';
import HeroStory from '../components/HeroStory';
import HeroSupport from '../components/HeroSupport';
import HeroSwiper from '../components/HeroSwiper';
import HeroVideo from '../components/HeroVideo';
import HighlightDetails from '../components/HighlightDetails';
import HighlightSlider from '../components/HighlightSlider';
import HorizontalScrolling from '../components/HorizontalScrolling';
import Hotspot from '../components/Hotspot';
import IconContent from '../components/IconContent';
import IconList from '../components/IconList';
import IframePage from '../components/IframePage';
import ImageBanner from '../components/ImageBanner';
import ImageGrid from '../components/ImageGrid';
import ImageOverlay from '../components/ImageOverlay';
import ImageOverlayV2 from '../components/ImageOverlayV2';
import ImmersiveImage from '../components/ImmersiveImage';
import ImmersiveSlider from '../components/ImmersiveSlider';
import InfoModal from '../components/InfoModal';
import InteriorDisplay from '../components/InteriorDisplay';
import IntroductionBlock from '../components/IntroductionBlock';
import KeyFeaturesPoster from '../components/KeyFeaturesPoster';
import KeywordDisplay from '../components/KeywordDisplay';
import LargeImageContent from '../components/Large-Image-Content';
import ListCarousel from '../components/ListCarousel';
import ListContent from '../components/ListContent';
import ListSwiper from '../components/ListSwiper';
import LiveBroadcast from '../components/LiveBroadcast';
import LocalHeroIntro from '../components/LocalHeroIntro';
import Login from '../components/Login';
import LogoSlide from '../components/LogoSlide';
import LogoutCustomer from '../components/LogoutCustomer';
import MarketDetector from '../components/Market-Detector';
import MediaCollection from '../components/MediaCollection';
import MediaDisplay from '../components/MediaDisplay';
import MediaKit from '../components/MediaKit';
import MembershipModal from '../components/MembershipModal';
import Modal from '../components/Modal';
import Modeldisplay from '../components/Modeldisplay';
import MultiSwiper from '../components/MultiSwiper';
import MyAccountCases from '../components/MyAccountCases';
import MyAccountDataAndPrivacy from '../components/MyAccountDataAndPrivacy';
import MyAccountMembership from '../components/MyAccountMembership';
import MyAccountMembershipNew from '../components/MyAccountMembershipNew';
import MyAccountOverview from '../components/MyAccountOverview';
import MyAccountPaymentHistory from '../components/MyAccountPaymentHistory';
import MyAccountPayMethods from '../components/MyAccountPayMethods';
import MyAccountPersonalInfo from '../components/MyAccountPersonalInfo';
import MyAccountSetting from '../components/MyAccountSetting';
import NestedImageSwiper from '../components/NestedImageSwiper';
import News from '../components/News';
import NewsDetail from '../components/NewsDetail';
import NewsHeader from '../components/NewsHeader';
import Newsletter from '../components/Newsletter';
import NewsletterCTA from '../components/NewsletterCTA';
import NewsList from '../components/NewsList';
import Notice from '../components/Notice';
import OpenPositions from '../components/OpenPositions';
import OpenPositionsTeamtailor from '../components/OpenPositionsTeamtailor';
import OwnersManual from '../components/OwnersManual';
import pagination from '../components/pagination';
import PaymentWidget from '../components/PaymentWidget';
import PayOrderCallbackRedirect from '../components/PayOrderCallbackRedirect';
import PdfView from '../components/PdfView';
import Pdp from '../components/Pdp';
import PdpDeliveryOptions from '../components/PdpDeliveryOptions';
import PdpOrderConfirmation from '../components/PdpOrderConfirmation';
import PdpOutOfStockBanner from '../components/PdpOutOfStockBanner';
import PdpPayment from '../components/PdpPayment';
import PdpShippingBilling from '../components/PdpShippingBilling';
import PdpTradeIn from '../components/PdpTradeIn';
import PhotoWall from '../components/PhotoWall';
import PreSalesCheckout from '../components/PreSalesCheckout';
import PreSalesCreateAccount from '../components/PreSalesCreateAccount';
import PreSalesLogin from '../components/PreSalesLogin';
import PreSalesOrderConfirmation from '../components/PreSalesOrderConfirmation';
import ProductDetail from '../components/ProductDetail';
import ProductSpecs from '../components/ProductSpecs';
import QuoteContent from '../components/QuoteContent';
import RedirectByDevice from '../components/RedirectByDevice';
import Regional from '../components/Regional';
import RegionModal from '../components/RegionModal';
import RegularService from '../components/RegularService';
import RepeatedRotation from '../components/RepeatedRotation';
import ResetPassword from '../components/ResetPassword';
import RollingSlider from '../components/RollingSlider';
import SectionTitle from '../components/SectionTitle';
import SetNewPassword from '../components/SetNewPassword';
import ShowRoom from '../components/ShowRoom';
import SimpleText from '../components/SimpleText';
import SingleVideo from '../components/SingleVideo';
import SocialFeed from '../components/Social-Feed';
import SocialMedia from '../components/Social-Media';
import StaffBanner from '../components/StaffBanner';
import StaffSignin from '../components/StaffSignin';
import StickyButton from '../components/StickyButton';
import SubNavigation from '../components/SubNavigation';
import Summary from '../components/Summary';
import SynthetisTestDriver from '../components/SynthetisTestDriver';
import TableContent from '../components/Table-Content';
import TableHighlight from '../components/TableHighlight';
import TabMenuAnyContent from '../components/TabMenuAnyContent';
import TabMenuContent from '../components/TabMenuContent';
import TestDrive from '../components/TestDrive';
import TestDriveV2 from '../components/TestDriveV2';
import TextBlock from '../components/TextBlock';
import TextContent from '../components/TextContent';
import TitleAnimation from '../components/TitleAnimation';
import TopNews from '../components/TopNews';
import TriangleGroup from '../components/TriangleGroup';
import TwoColumnLinkList from '../components/TwoColumnLinkList';
import TwoImagesContent from '../components/TwoImagesContent';
import Typewriting from '../components/Typewriting';
import Unsubscribe from '../components/Unsubscribe';
import UnSubscribeNew from '../components/UnSubscribeNew';
import UserManual from '../components/UserManual';
import videojs from '../components/video-js';
import VideoPlay from '../components/VideoPlay';
import VideoSwitch from '../components/VideoSwitch';
import VisitSum from '../components/VisitSum';
import WaterFall from '../components/WaterFall';
import WaterfallFlow from '../components/WaterfallFlow';
import WorldwidePresence from '../components/WorldwidePresence';
import WtcrContent from '../components/WtcrContent';

const components = new Map();
components.set('AboutUs', AboutUs);
components.set('Accordion', Accordion);
components.set('AdaptiveImages', AdaptiveImages);
components.set('Adas', Adas);
components.set('AppPushModule', AppPushModule);
components.set('Auto-List-Content', AutoListContent);
components.set('B2BContact', B2BContact);
components.set('BalancedDesign', BalancedDesign);
components.set('BecomeAMember', BecomeAMember);
components.set('BecomeAMemberFlow', BecomeAMemberFlow);
components.set('BecomeAMemberSummary', BecomeAMemberSummary);
components.set('BookingCarDelivery', BookingCarDelivery);
components.set('BrandDetail', BrandDetail);
components.set('BrandImageList', BrandImageList);
components.set('BrandList', BrandList);
components.set('BrandTechnology', BrandTechnology);
components.set('Breadcrumbs', Breadcrumbs);
components.set('CalculationTool', CalculationTool);
components.set('Car360View', Car360View);
components.set('Car360ViewV2', Car360ViewV2);
components.set('CarBookingConfirmation', CarBookingConfirmation);
components.set('CarBookingDatetime', CarBookingDatetime);
components.set('CarBookingDelivery', CarBookingDelivery);
components.set('CarBookingPayment', CarBookingPayment);
components.set('CarDeliveryLogin', CarDeliveryLogin);
components.set('CarModel', CarModel);
components.set('Cart', Cart);
components.set('CartAlert', CartAlert);
components.set('CartRefreshBanner', CartRefreshBanner);
components.set('ChangeMarketModal', ChangeMarketModal);
components.set('CheckoutCreateAccount', CheckoutCreateAccount);
components.set('CheckoutLogin', CheckoutLogin);
components.set('CheckoutOrderConfirmation', CheckoutOrderConfirmation);
components.set('CheckoutPayment', CheckoutPayment);
components.set('CheckoutShippingBilling', CheckoutShippingBilling);
components.set('CoclubModels', CoclubModels);
components.set('CoclubSwiper', CoclubSwiper);
components.set('ColorInChange', ColorInChange);
components.set('ComparisonTool', ComparisonTool);
components.set('Consent', Consent);
components.set('ContactSupport', ContactSupport);
components.set('ContactSupportDecember', ContactSupportDecember);
components.set('ContactUs', ContactUs);
components.set('Cookies', Cookies);
components.set('Countdown', Countdown);
components.set('CreateAccount', CreateAccount);
components.set('CTA-Banner', CTABanner);
components.set('CTA-Button', CTAButton);
components.set('CurtainsSlide', CurtainsSlide);
components.set('DataPrivacyPolicy', DataPrivacyPolicy);
components.set('DealerMap', DealerMap);
components.set('DealerSearch', DealerSearch);
components.set('Declare', Declare);
components.set('DPP', DPP);
components.set('DriveModels', DriveModels);
components.set('Emotive', Emotive);
components.set('ExploreMore', ExploreMore);
components.set('FAQ', FAQ);
components.set('FindDealer', FindDealer);
components.set('FloatingActionButton', FloatingActionButton);
components.set('Footer', Footer);
components.set('FourZeroFourGame', FourZeroFourGame);
components.set('FreeRolling', FreeRolling);
components.set('FullScreenBanner', FullScreenBanner);
components.set('FunPrint', FunPrint);
components.set('GearLanding', GearLanding);
components.set('GraphicCombination', GraphicCombination);
components.set('Header', Header);
components.set('Helpful', Helpful);
components.set('HeroBanner', HeroBanner);
components.set('HeroContent', HeroContent);
components.set('HeroImage', HeroImage);
components.set('HeroLanding', HeroLanding);
components.set('HeroMedia', HeroMedia);
components.set('HeroSlide', HeroSlide);
components.set('HeroSlideV2', HeroSlideV2);
components.set('HeroStory', HeroStory);
components.set('HeroSupport', HeroSupport);
components.set('HeroSwiper', HeroSwiper);
components.set('HeroVideo', HeroVideo);
components.set('HighlightDetails', HighlightDetails);
components.set('HighlightSlider', HighlightSlider);
components.set('HorizontalScrolling', HorizontalScrolling);
components.set('Hotspot', Hotspot);
components.set('IconContent', IconContent);
components.set('IconList', IconList);
components.set('IframePage', IframePage);
components.set('ImageBanner', ImageBanner);
components.set('ImageGrid', ImageGrid);
components.set('ImageOverlay', ImageOverlay);
components.set('ImageOverlayV2', ImageOverlayV2);
components.set('ImmersiveImage', ImmersiveImage);
components.set('ImmersiveSlider', ImmersiveSlider);
components.set('InfoModal', InfoModal);
components.set('InteriorDisplay', InteriorDisplay);
components.set('IntroductionBlock', IntroductionBlock);
components.set('KeyFeaturesPoster', KeyFeaturesPoster);
components.set('KeywordDisplay', KeywordDisplay);
components.set('Large-Image-Content', LargeImageContent);
components.set('ListCarousel', ListCarousel);
components.set('ListContent', ListContent);
components.set('ListSwiper', ListSwiper);
components.set('LiveBroadcast', LiveBroadcast);
components.set('LocalHeroIntro', LocalHeroIntro);
components.set('Login', Login);
components.set('LogoSlide', LogoSlide);
components.set('LogoutCustomer', LogoutCustomer);
components.set('Market-Detector', MarketDetector);
components.set('MediaCollection', MediaCollection);
components.set('MediaDisplay', MediaDisplay);
components.set('MediaKit', MediaKit);
components.set('MembershipModal', MembershipModal);
components.set('Modal', Modal);
components.set('Modeldisplay', Modeldisplay);
components.set('MultiSwiper', MultiSwiper);
components.set('MyAccountCases', MyAccountCases);
components.set('MyAccountDataAndPrivacy', MyAccountDataAndPrivacy);
components.set('MyAccountMembership', MyAccountMembership);
components.set('MyAccountMembershipNew', MyAccountMembershipNew);
components.set('MyAccountOverview', MyAccountOverview);
components.set('MyAccountPaymentHistory', MyAccountPaymentHistory);
components.set('MyAccountPayMethods', MyAccountPayMethods);
components.set('MyAccountPersonalInfo', MyAccountPersonalInfo);
components.set('MyAccountSetting', MyAccountSetting);
components.set('NestedImageSwiper', NestedImageSwiper);
components.set('News', News);
components.set('NewsDetail', NewsDetail);
components.set('NewsHeader', NewsHeader);
components.set('Newsletter', Newsletter);
components.set('NewsletterCTA', NewsletterCTA);
components.set('NewsList', NewsList);
components.set('Notice', Notice);
components.set('OpenPositions', OpenPositions);
components.set('OpenPositionsTeamtailor', OpenPositionsTeamtailor);
components.set('OwnersManual', OwnersManual);
components.set('pagination', pagination);
components.set('PaymentWidget', PaymentWidget);
components.set('PayOrderCallbackRedirect', PayOrderCallbackRedirect);
components.set('PdfView', PdfView);
components.set('Pdp', Pdp);
components.set('PdpDeliveryOptions', PdpDeliveryOptions);
components.set('PdpOrderConfirmation', PdpOrderConfirmation);
components.set('PdpOutOfStockBanner', PdpOutOfStockBanner);
components.set('PdpPayment', PdpPayment);
components.set('PdpShippingBilling', PdpShippingBilling);
components.set('PdpTradeIn', PdpTradeIn);
components.set('PhotoWall', PhotoWall);
components.set('PreSalesCheckout', PreSalesCheckout);
components.set('PreSalesCreateAccount', PreSalesCreateAccount);
components.set('PreSalesLogin', PreSalesLogin);
components.set('PreSalesOrderConfirmation', PreSalesOrderConfirmation);
components.set('ProductDetail', ProductDetail);
components.set('ProductSpecs', ProductSpecs);
components.set('QuoteContent', QuoteContent);
components.set('RedirectByDevice', RedirectByDevice);
components.set('Regional', Regional);
components.set('RegionModal', RegionModal);
components.set('RegularService', RegularService);
components.set('RepeatedRotation', RepeatedRotation);
components.set('ResetPassword', ResetPassword);
components.set('RollingSlider', RollingSlider);
components.set('SectionTitle', SectionTitle);
components.set('SetNewPassword', SetNewPassword);
components.set('ShowRoom', ShowRoom);
components.set('SimpleText', SimpleText);
components.set('SingleVideo', SingleVideo);
components.set('Social-Feed', SocialFeed);
components.set('Social-Media', SocialMedia);
components.set('StaffBanner', StaffBanner);
components.set('StaffSignin', StaffSignin);
components.set('StickyButton', StickyButton);
components.set('SubNavigation', SubNavigation);
components.set('Summary', Summary);
components.set('SynthetisTestDriver', SynthetisTestDriver);
components.set('Table-Content', TableContent);
components.set('TableHighlight', TableHighlight);
components.set('TabMenuAnyContent', TabMenuAnyContent);
components.set('TabMenuContent', TabMenuContent);
components.set('TestDrive', TestDrive);
components.set('TestDriveV2', TestDriveV2);
components.set('TextBlock', TextBlock);
components.set('TextContent', TextContent);
components.set('TitleAnimation', TitleAnimation);
components.set('TopNews', TopNews);
components.set('TriangleGroup', TriangleGroup);
components.set('TwoColumnLinkList', TwoColumnLinkList);
components.set('TwoImagesContent', TwoImagesContent);
components.set('Typewriting', Typewriting);
components.set('Unsubscribe', Unsubscribe);
components.set('UnSubscribeNew', UnSubscribeNew);
components.set('UserManual', UserManual);
components.set('video-js', videojs);
components.set('VideoPlay', VideoPlay);
components.set('VideoSwitch', VideoSwitch);
components.set('VisitSum', VisitSum);
components.set('WaterFall', WaterFall);
components.set('WaterfallFlow', WaterfallFlow);
components.set('WorldwidePresence', WorldwidePresence);
components.set('WtcrContent', WtcrContent);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
